export default "__VITE_ASSET__C5c5c3fk__"